import * as React from 'react'
import Popover from '@mui/material/Popover'
import { useData, useHandlers, useFetchAllEntityActivities } from './hooks'
import type { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  salesTeamId: number
  ownerId: string | null
}

const anchorOrigin = {
  vertical: 'bottom' as const,
  horizontal: 'left' as const,
}

export function ActivitiesContent(props: Props) {
  const { entityId, entityType, salesTeamId, ownerId } = props
  const { contentOpened, popoverEl, Content } = useData()
  const { handleClose } = useHandlers()

  useFetchAllEntityActivities(entityId, entityType)

  return (
    <Popover
      id="popover"
      open={contentOpened}
      anchorEl={popoverEl}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Content
        salesTeamId={salesTeamId}
        entityId={entityId}
        ownerId={ownerId}
        entityType={entityType}
      />
    </Popover>
  )
}
